<div class="sidenav">
    <h4>About Us</h4>
    <a style="font-weight: bold; color: #753457;">What it's all about</a>
    <mat-divider></mat-divider>
    <a href="/partners">Friends and Partners</a>
    <mat-divider></mat-divider>
    <a href="/getintouch">Get in touch</a>
    <mat-divider></mat-divider>
    <a href="/apidocs">API docs</a>
  </div>


  <div class="navmobile">
    <h4>About Us</h4>
    <a style="font-weight: bold; color: #753457;" href="#about">What it's all about</a>
    <mat-divider></mat-divider>
    <a href="/partners">Friend and Partners</a>
    <mat-divider></mat-divider>
    <a href="/getintouch">Get in touch</a>
    <mat-divider></mat-divider>
    <a href="/apidocs">API docs</a>
  </div>
  <div class="center">
    <h2>What it's all about</h2>
    <img src='/assets/about_events.png'>
    <div class="row">
        <div class="col">
            <strong>Have  you ever wondered if there was a single place online that you could go to and find out everything that was happening in the country?</strong><br><br>


            One place where you could check out and pick which seminars or art exhibitions you'd like to attend, what concerts you shouldn't miss, where you could take your kids for some fun time, with whom you could go for a fresh nature hike, etc?
            Read more on https://www.lebtivity.com/p/about
        </div>
        <div class="col">
            Lebtivity offers anyone interested in planning an evening, a weekend or a summer vacation, the possibility to explore and pick their favorite events and create their personalized event schedule. Initially covering events happening outside the city such as hiking and camping, Lebtivity gradually increased its geographical coverage as well as the diversity of the events. You can find cultural, musical, and culinary events as well as conferences, exhibitions and activities for everyone including families and youth.


            Read more on https://www.lebtivity.com/p/about
        </div>


    </div>
    <div class="row">

            <button (click)="goToMain()" mat-raised-button class="whatshappening">Check out what's happening this month >></button>


    </div>

    <div class="row">

        <h3><span>Our Mission</span></h3>
        <p style="margin-top: 40px; width: 95%;">Lebtivity was created by five young Lebanese residents who are passionate about Lebanon and the web. They saw in this an opportunity to prove that talent and expertise can still be found in the country, and applied their strengths in developing a tool that would also highlight the country's rich cultural diversity and the various activities and events that are taking place.
            Read more on https://www.lebtivity.com/p/about</p>


</div>
     </div>  
  